module.exports =
{
    theme: 'dark', // 'dark', 'light'
    // Meta Tags für Facebook, Twitter
    meta: {
        // Seiten Title
        title: 'Atomendlager in 3D - eine interaktive Story',
        // Beschreibung
        description: 'Die letzten deutschen AKW gehen vom Netz - doch der Atommüll bleibt. Ein Beispiel aus Finnland zeigt, wie ein Endlager aussehen könnte. Erkunden Sie es in der interaktiven 3D-Story.',
        // Bild
        image: 'https://3d.zdf.de/atomendlager/img/Story-Link-Preview.jpg',
        // URL
        url: 'https://3d.zdf.de/atomendlager/',
    },
    tracking: {
        storyName: 'atomendlager',
        storyID: 'atomendlager',
        // Tracking deaktivieren
        //disabled: true,
    },
    babylon: { 
        lightIntensity : 1,

        camera: {
            // Position, Ausrichtung und Kamera Bewegung
            // Kamera Position
            position: [.5 * Math.PI, .5 * Math.PI, 10], // alpha, beta, radius
            moveFunction: 'move', // Wie die Kamera bewegt wird: 'move' Kamerafahrt, 'set' Springt zur Position
            target: [0, 0, 0], // Wohin die Kamera blickt
            animationSpeed: 280, // Geschwindigkeit der Kamerabewegung

            // Begrenzungen
            alphaLimits: [null, null],
            betaLimits: [0.1, Math.PI / 2],
            radiusLimits: [1, 20], // minCamRadius, maxCamRadius
            clipping: [1, 10000.0],
            fov: 0.8,

            // Automatisches Drehen
            useAutoRotationBehavior: false,
            idleRotationSpeed: 0.05,

            // Steuerung
            panSensibility: 0, // 0 is deactivated
            wheelPrecision: 100.0, // 3.0 ist Standard
        },
    },
    audio: {
        enabled: true
    },
    objects:
    [
        /* {
            // Name des Objekts zur Ansteuerung
            name: "zdfLogo",
            // GLB Dateiname im Ordner app/public/3d-models
            filename: "ZDF_Logo.glb",
            options: {
                //// BaseObject
                // true: Objekt anzeigen
                visible: true,
                // Skalierung: Objekt Größe ändern in allen Dimensionen
                scaling: [1, 1, -1],
                // Skalierung: Objekt Größe ändern (Alle Dimensionen gleich)
                //scale: 0.01,
                // Position
                position: [0, 0, 0],
                // Rotation
                rotation: [0.5 * Math.PI, 0, 0],
                // Rotation Quaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
                //rotationQuaternion: [0.707, 0, 0, 0.707],
                // Transparenz (0 bis 1)
                //visibility: 0.25,
                // RGB-Farbe (diffuse) jeweils Werte 0 bis 255
                //diffuse: [255, 0, 0],
                // Zur Kamera ausrichten
                // 1: X-Achse, 2: Y-Achse, 4: Z-Achse, 7: Alle Achsen
                // 3: X & Y-Achse, 5: Z & X-Achse, 6: Z & Y-Achse
                // https://doc.babylonjs.com/typedoc/classes/babylon.abstractmesh#billboardmode
                billboardMode: 0,
                // Overlay Color zum hervorheben von Objekten
                //overlayColor: [250/255, 125/255, 25/255],
                // Rendering Group ID legt Objekte eine ebene nach vorne (Auch beim Hotspot)
                //renderingGroupId: 1

                //// MeshObject
                // Objekt mit Fade ein und ausblenden, wenn visible sich ändert
                fade: false,
                // Unter-Mesh-Objekte in der Datei
                // Name des Meshs wie im 3D Model
                ZDF_Logo: {
                    visible: true,
                    fade: false,
                    // Ist das Objekt anklickbar?
                    // Bei true wird ein Hotspot durch das Objekt nicht anklickbar, wenn verdeckt.
                    // Darum sollte bei transparenten Objekten ggf. pickable: false gesetzt werden.
                    pickable: true,

                    ZDF_Logo_2: {
                        visible: true,
                        fade: false,
                    }
                },

                //// BabylonObject
                // animation=true: startet die Animation im Objekt
                animation: false,

                // Nur initial, nicht per babylonState
                // OnClick Trigger
                // trigger: function () { }
            },
            // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
            callback: function (zdfLogo) // eslint-disable-line no-unused-vars
            {

            }
        }, */

        {
            name: "geo_kraftwerke",
            filename: "kraftwerke_06_aw.glb",
            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [-.1, .1, .1],
                rotation: [0, 0, 0],
            },
        },

        {
            name: "geo_teilgebiete",
            filename: "teilgebiete_02_aw.glb",
            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [-.1, .1, .1],
                rotation: [0, 0, 0],
            },
        },


        {
            name: "geo_atomendlager",
            filename: "atomendlager_06_aw.glb",
            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [-1, 1, 1],
                rotation: [0, 0, 0],
                children: {
                    Abfahrt: false,
                    Ausschnitt: false,
                    Behaelter: false,
                    Behaelter_seperat_1: false,
                    Behaelter_seperat_2: false,
                    Flagge: false,
                    Fuellungen: false,
                    Gestein_Granit: false,
                    Gestein_Salz: false,
                    Gestein_Ton: false,
                    Glas: false,
                    Rueckwand: false,
                    Schacht_001: false,
                    Schacht_002: false,
                    Schacht_003: false,
                    Schacht_004: false,
                    Stadt: false,
                    System: false,
                },
            },
        },

        {
            name: "geo_labels",
            filename: "atomendlager-labels_05_aw.glb",
            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [-1, 1, 1],
                rotation: [0, 0, 0],
                children: {
                    Label_Behaelter_BG: false,
                    Label_Behaelter_Text: false,
                    Label_Belueftung_BG: false,
                    Label_Belueftung_Text: false,
                    Label_Entlueftung_BG: false,
                    Label_Entlueftung_Text: false,
                    Label_Personen_BG: false,
                    Label_Personen_Text: false,
                    Label_Tunnel_BG: false,
                    Label_Tunnel_Text: false,
                    Radioactive: false,
                },
            },
        },

    ]
};
